import Container from "@components/Container/Container";
import { useWindowSize } from "@hooks/useWindowSize";

import E50FooterDesktop from "./E50FooterDesktop";
import E50FooterMobile from "./E50FooterMobile";

/**
 * Component to display footer in E50 pages
 */
const E50Footer = (): React.ReactElement => {
  const { isScreenLG } = useWindowSize();

  return (
    <footer
      data-testid="e50-footer-component"
      className="mb-4 bg-gray-850 py-9 font-public-sans"
    >
      <Container rootClassName="flex flex-row justify-center text-white">
        {isScreenLG ? <E50FooterDesktop /> : <E50FooterMobile />}
      </Container>
    </footer>
  );
};

export default E50Footer;
